export default "__VITE_ASSET__5ff945ae__"